import React, { useState } from 'react';
import GridShape from "@/components/common/GridShape";
import PageMeta from "@/components/common/PageMeta";

interface ErrorPageProps {
  error: Error | null;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ error }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyError = () => {
    if (error) {
      const errorDetails = `
Error: ${error.message}
Stack Trace:
${error.stack}
      `;

      navigator.clipboard.writeText(errorDetails).then(
        () => {
          setIsCopied(true);
          // Возвращаем исходное состояние через 2 секунды
          setTimeout(() => {
            setIsCopied(false);
          }, 2000);
        },
        (err) => {
          console.error('Failed to copy error details:', err);
        }
      );
    }
  };

  const handleBackHome = () => {
    window.location.href = '/';
  };

  return (
    <>
      <PageMeta
        title="Error | Admin.Drivitive"
        description="Something went wrong"
      />
      <div className="relative flex flex-col items-center justify-center min-h-screen p-6 overflow-hidden z-1">
        <GridShape />
        <div className="mx-auto w-full max-w-[242px] text-center sm:max-w-[472px]">
          <h1 className="mb-8 font-bold text-gray-800 text-title-md dark:text-white/90 xl:text-title-2xl">
            ERROR
          </h1>

          {/* <img src="/images/error/404.svg" alt="error" className="dark:hidden" />
          <img
            src="/images/error/404-dark.svg"
            alt="error"
            className="hidden dark:block"
          /> */}

          <p className="mt-10 mb-2 text-base text-gray-700 dark:text-gray-400 sm:text-lg">
            Something went wrong!
          </p>

          {error && (
            <p className="mb-6 text-sm text-red-500 dark:text-red-400">
              {error.message}
            </p>
          )}

          <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
            <button
              onClick={handleBackHome}
              className="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-5 py-3.5 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200"
            >
              Back to Home Page
            </button>

            <button
              onClick={handleCopyError}
              disabled={isCopied}
              className={`inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-5 py-3.5 text-sm font-medium ${
                isCopied
                  ? 'text-green-600 dark:text-green-400 cursor-default'
                  : 'text-gray-700 hover:bg-gray-50 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200'
              } shadow-theme-xs dark:border-gray-700 dark:bg-gray-800`}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {isCopied ? (
                  <path
                    d="M9 20.25L3.75 15M3.75 15L9 9.75M3.75 15H16.5C18.0913 15 19.6174 14.3679 20.7426 13.2426C21.8679 12.1174 22.5 10.5913 22.5 9C22.5 7.4087 21.8679 5.88258 20.7426 4.75736C19.6174 3.63214 18.0913 3 16.5 3H12"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                ) : (
                  <>
                    <path
                      d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M22 6.9V11.1C22 14.6 20.6 16 17.1 16H16V12.9C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2H17.1C20.6 2 22 3.4 22 6.9Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </>
                )}
              </svg>
              {isCopied ? 'Copied!' : 'Copy Error Details'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ErrorPage;
